import {
	DEFAULT_LOCALE,
	VALID_LOCALES_SET,
	type ValidLocale,
} from '@/constants/locales';
import { isPageLocalized } from './localizedPages';

const normalizePathname = (pathname: string): string => {
	const clean = (pathname || '/').split('?')[0]?.split('#')[0]?.trim() || '/';
	if (!clean.startsWith('/')) {
		return `/${clean}`;
	}
	return clean || '/';
};

export const stripLeadingLocaleFromPath = (pathname: string): string => {
	const normalizedPath = normalizePathname(pathname);
	const segments = normalizedPath.split('/').filter(Boolean);

	if (segments.length === 0) {
		return '/';
	}

	const [first, ...rest] = segments;
	if (VALID_LOCALES_SET.has(first.toLowerCase())) {
		return rest.length > 0 ? `/${rest.join('/')}` : '/';
	}

	return normalizedPath;
};

interface BuildLocaleHrefOptions {
	fallbackToHomeOnNonLocalized?: boolean;
	prefixDefaultLocale?: boolean;
}

export const buildLocaleHref = (
	pathname: string,
	targetLocale: ValidLocale,
	options?: BuildLocaleHrefOptions,
): string => {
	const cleanPath = stripLeadingLocaleFromPath(pathname);
	const isLocalized = isPageLocalized(cleanPath);
	const prefixDefaultLocale = options?.prefixDefaultLocale === true;

	if (!isLocalized) {
		if (
			options?.fallbackToHomeOnNonLocalized &&
			targetLocale !== DEFAULT_LOCALE
		) {
			return `/${targetLocale}`;
		}

		return cleanPath;
	}

	if (targetLocale === DEFAULT_LOCALE) {
		if (!prefixDefaultLocale) {
			return cleanPath;
		}

		return cleanPath === '/'
			? `/${DEFAULT_LOCALE}`
			: `/${DEFAULT_LOCALE}${cleanPath}`;
	}

	return cleanPath === '/'
		? `/${targetLocale}`
		: `/${targetLocale}${cleanPath}`;
};
